<template>
  <div>
    <div class="banner" :class="use">
      <div class="info container">
        <slot name="info-content"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: ['use', 'isMobile'],
  components: {},
  methods: {}
}
</script>
<style scoped lang="sass">
@import '../../style/bulma/app.sass'
.banner
  width: 100vw
  padding-top: 80px
  display: flex
  justify-content: center
  align-items: center
  &.home
    height: 56vw
    background: url(./assets/banner.png) center center
  &.home
    .container
      width: 1152px !important
      max-width: 1344px !important
    +mobile
      height: 151vw
      background: url(https://static001-test.geekbang.org/resource/image/e2/6a/e2d5ebfe7e51eb92fbf5b314dbadef6a.png) center center
      background-size: cover
      align-items: flex-end
    .info
      margin-bottom: 16px
  &.join
    height: 56vw
    background: url(./assets/join-banner2.png) center center
    background-size: cover
    +mobile
      height: 148vw
      background: url(./assets/recruit-m.png) center center
      background-size: cover
  .info
    // align-items: center
    +desktop
      margin-bottom: 120px
    +mobile
      margin-bottom: 66px
</style>
